import { useEffect, useRef, useState } from 'react';
import { TaskTimer } from 'tasktimer';

/**
 * Timer that triggers a rerender every time after a set interval
 * Uses the task timer to avoid timer drifting inherent in setInterval
 * returns the time passed
 */
export const useTimer = (initialTimeMs: number, interval = 1000): number => {

  // Ref containing that amount of milliseconds that have passed
  const ref = useRef<number>(initialTimeMs);

  // Empty state hook that will simply trigger a rerender
  const [,rerender] = useState<object>();

  // Create a timer with a set interval that updates the amount of time passed
  useEffect(() => {

    const timer = new TaskTimer(interval).start();

    timer.on('tick', () => {

      ref.current += interval;
      rerender({});

    });

    return () => {

      timer.stop();

    };

  }, [interval]);

  return ref.current;

};
